export enum FieldTypeId {
  TEXT = 1,
  DATE = 2,
  DECIMAL = 3,
  INTEGER = 4,
  DROPLIST = 5,
  MULTISELECT = 6,
  RADIO_BUTTON_LIST = 8,
  MULTILINE_TEXT = 9,
  CHECKBOX = 10,
  CHECKBOX_LIST = 15,
}

export enum FieldAlias {
  D_EQ5D_1_RORLIGHET = "D_EQ5D_1_Rorlighet",
  D_EQ5D_2_HYGIEN = "D_EQ5D_2_Hygien",
  D_EQ5D_3_HUVUDSAKLIGAAKTRIVITETER = "D_EQ5D_3_HuvudsakligaAktiviteter",
  D_EQ5D_4_SMARTOR = "D_EQ5D_4_Smartor",
  D_EQ5D_5_ORO = "D_EQ5D_5_Oro",
  D_EQ5D_6_VAS = "D_EQ5D_6_VAS",
  D_EQ5D_DATUM = "D_EQ5D_Datum",
  C_F_D_DIARY_COLD = "C_F_D_Diary_Cold",
  C_F_D_DIARY_DRYCOUGH = "C_F_D_Diary_DryCough",
  C_F_D_DIARY_EARPAIN = "C_F_D_Diary_EarPain",
  C_F_D_DIARY_FEELINGSICK = "C_F_D_Diary_FeelingSick",
  C_F_D_DIARY_FEVER = "C_F_D_Diary_Fever",
  C_F_D_DIARY_FLEMCOUGH = "C_F_D_Diary_FlemCough",
  C_F_D_DIARY_MORNINGCOUGH = "C_F_D_Diary_MorningCough",
  C_F_D_DIARY_STOMACHACHE = "C_F_D_Diary_StomachAche",
  C_F_D_DIARY_THROATPAIN = "C_F_D_Diary_ThroatPain",
  C_F_D_DIARY_TIREDNESS = "C_F_D_Diary_Tiredness",
  C_F_D_DIARY_NOSYMPTOM = "C_F_D_Diary_NoSymtom",
  D_VACCINATIONTYPE = "D_VaccinationType",
  D_SJUKSKRIVNING_1_START_DATUM = "D_Sjukskrivning_1_Start_Datum",
  D_SJUKSKRIVNING_2_SLUT_DATUM = "D_Sjukskrivning_2_Slut_Datum",
  D_SJUKSKRIVNING_3_INFECTIONRELATED = "D_Sjukskrivning_3_InfectionRelated",
  D_SJUKSKRIVNING_4_WORKING = "D_Sjukskrivning_4_Working",
  D_SJUKSKRIVNING_5_WORKINGPERCENT = "D_Sjukskrivning_5_WorkingPercent",
  D_SJUKSKRIVNING_NUMBEROFDAYS = "D_Sjukskrivning_NumberOfDays",
  D_CAREDAYS_1_DATESTART = "D_CareDays_1_DateStart",
  D_CAREDAYS_2_DATEEND = "D_CareDays_2_DateEnd",
  D_CAREDAYS_3_INFECTION = "D_CareDays_3_Infection",
  C_D_CAREDAYS_NUMBER_OF_DAYS = "C_D_CareDaysNbrOfDays",
  D_PERGAMMA_1_DATE = "D_PERGamma_1_Date",
  D_PERGAMMA_2_DRUG = "D_PERGamma_2_Drug",
  D_PERGAMMA_3_DOSAGE = "D_PERGamma_3_Dosage",
  D_PERGAMMA_4_BATCH = "D_PERGamma_4_Batch",
  D_PERGAMMA_5_ADVERSE_EVENT = "D_PERGamma_5_AdverseEvent",
  C_D_PERGAMMA_DOSAGE = "C_D_PERGammaDosage",
  D_PERDIAGNOS = "D_PERDiagnos",
  D_PERDRUGS = "D_PERDrugs",
  D_PERCOMMENTS = "D_PERComments",
  D_DIAGNOSIS_DATE_END = "D_DiagnosisDateEnd",
  D_DIAGNOSIS_SUB_SYNDROM_MED_AUTOIMMUNITET = "D_DiagnosisSubSyndromMedAutoimmunitet",
}

export enum FieldId {
  BIVERKNINGAR_FIELD_ID = 1001599,
  DRUGS_FIELD_ID = 1001602,
  VACCINATIONS_FIELD_ID = 1000527,
  C_D_PERGAMMA_DOSAGE = 1001600,
}

export enum FieldGroupId {
  SICKDAYS_FIELD_GROUP_ID = 1000021,
  EQ5D5L_FIELD_GROUP_ID = 1000034,
  CAREDAYS_FIELD_GROUP_ID = 1000050,
  IMMUNOGLOBULIN_FIELD_GROUP_ID = 1000053,
}

export enum FieldOptionGroupId {
  D_EQ5D5L_ANXIETY_DEPRESSION_OPTIONS_ID = 1000056,
  D_EQ5D5L_PAIN_DISCOMFORT_OPTIONS_ID = 1000055,
  D_EQ5D5L_USUAL_ACTIVITIES_OPTIONS_ID = 1000054,
  D_EQ5D5L_HYGIEN_OPTIONS_ID = 1000053,
  D_EQ5D5L_MOBILITY_OPTIONS_ID = 1000052,
  C_D_F_DIARY_YES_OPTIONS_ID = 1000148,
  D_VACCINATIONTYPE_OPTIONS_ID = 1000060,
  D_SJUKSKRIVNING_YES_NO_PARTLY_OPTIONS_ID = 1000022,
  D_SJUKSKRIVNING_WORKING_PERCENT_OPTIONS_ID = 1001162,
  D_SJUKSKRIVNING_INFECTION_RELATED_OPTIONS_ID = 1001177,
  D_PERGAMMA_ADVERSE_EVENT_OPTIONS_ID = 1001181,
  D_PERGAMMA_DRUG_OPTIONS_ID = 1001182,
  D_DIAGNOSIS_SUB_SYNDROM_MED_AUTOIMMUNITET_OPTIONS_ID = 1001184,
}
